import { ConfigKey } from "../enum/ConfigKey";

const defaultConfig: Record<ConfigKey, any> = {
  // Debug mode
  DEBUG: false,

  VERSION: "2.0.41",

  // The node environment (development | test | production)
  NODE_ENV: "development",

  REACT_APP_BACKEND_API_URL: "https://i4cast-backend.demo.i4sea.com.br",

  REACT_APP_FIREBASE_CREDENTIAL:
    "ewogICAgICAgICJwcm9qZWN0SWQiOiAiaTRjYXN0LWVtdWxhdG9yLXByb2plY3QtaWQiCn0=", //emulator procject id

  FIREBASE_FIRESTORE_EMULATOR_HOST: "0.0.0.0:8200",

  REACT_APP_CONTACT_URL: "https://www.i4sea.com/",

  REACT_APP_SENTRY_DSN: "",

  REACT_APP_PUBLIC_POSTHOG_KEY: "",

  REACT_APP_PUBLIC_POSTHOG_HOST: "https://us.i.posthog.com",

  REACT_APP_MAPTILER_KEY: "",

  // Parent app origin(s) for embedded mode authentication.
  // Comma-separated list to authorize multiple parent deployments.
  //
  // ⚠️ A validacao e por CASAMENTO EXATO -- `allowedOrigins.includes(event.origin)` em
  // `util/embedded.ts` -- entao nao ha curinga aqui, ao contrario do CORS_ORIGINS do
  // nautilus. Uma origem que falta nao degrada: o token nunca chega e a tela embutida
  // fica sem sessao. E o `IFRAME_READY` sai para o PRIMEIRO item da lista, entao a
  // ordem tambem nao e livre.
  //
  // `i4cast-demo-event-map.netlify.app` entra para o teste da workspace#385 (09/09/2026),
  // onde o aurora daquela URL embute este app. A mesma origem tambem precisa estar no
  // `frame-ancestors` do netlify.toml -- sao duas guardas diferentes: uma libera o
  // navegador a RENDERIZAR o iframe, a outra libera este app a ACEITAR o token.
  REACT_APP_PARENT_APP_URL:
    "https://i4cast-frontend-demo.i4sea.com.br,https://i4cast-frontend-embedded-demo.i4sea.com.br,https://i4cast-frontend-embedded-production.i4sea.com.br,https://i4cast-demo-c7d9e1a4.netlify.app,https://i4cast-demo-event-map.netlify.app",
};

export const getConfig = (key: ConfigKey): string => {
  return process.env[key] || defaultConfig[key];
};

/**
 * Parses REACT_APP_PARENT_APP_URL into a list of allowed parent origins.
 * Accepts a single URL or a comma-separated list. Each entry is normalized
 * to its origin (scheme + host), since postMessage validation compares
 * against `event.origin`, which never includes a path.
 */
export const getParentAppOrigins = (): string[] => {
  const toOrigins = (raw: string): string[] =>
    raw
      .split(",")
      .map((entry) => entry.trim())
      .filter(Boolean)
      .map((entry) => {
        try {
          return new URL(entry).origin;
        } catch {
          // Already an origin or malformed — fall back to the raw trimmed value.
          return entry;
        }
      });

  const origins = toOrigins(getConfig(ConfigKey.REACT_APP_PARENT_APP_URL));

  // Guard against an env var set to only whitespace/commas, which would
  // otherwise yield an empty allowlist and break embedded auth entirely.
  return origins.length > 0
    ? origins
    : toOrigins(defaultConfig.REACT_APP_PARENT_APP_URL);
};
